const o = {
  name: "DocumentLines",
  dimensions: { width: 18, height: 24 },
  content: `
    <g>
      <path fill="none" stroke="currentColor" stroke-width="2" d="M3 23H15C16.1046 23 17 22.1046 17 21V7.82843C17 7.29799 16.7893 6.78929 16.4142 6.41421L11.5858 1.58579C11.2107 1.21071 10.702 1 10.1716 1H3C1.89543 1 1 1.89543 1 3V21C1 22.1046 1.89543 23 3 23Z"/>
      <path fill="none" stroke="currentColor" d="M5 14L13 14" stroke-width="2" stroke-linecap="round"/>
      <path fill="none" stroke="currentColor" d="M5 18L13 18" stroke-width="2" stroke-linecap="round"/>
      <path fill="currentColor" stroke="none" d="M10 8H9C9 8.55228 9.44772 9 10 9V8ZM9 1V8H11V1H9ZM10 9H17V7H10V9Z"/>
    </g>
  `
};
export {
  o as DocumentLines
};
